export default __webpack_public_path__ + "static/media/3.0c325d68.jpg";